import Vue from 'vue'
import VueI18n from 'vue-i18n'
import jp from './jp.json'
import en from './en.json'
import tw from './tw.json'
import th from './th.json'
import ko from './ko.json'
import cn from './cn.json'
import id from './id.json'
import vn from './vn.json'
import easy from './easy.json'
import es from './es.json'

Vue.use(VueI18n)

export function initializeI18n (languageName) {
  return new VueI18n({
    locale: languageName,
    fallbackLocale: 'en',
    messages: {
      jp: jp,
      en: en,
      tw: tw,
      th: th,
      ko: ko,
      cn: cn,
      id: id,
      vn: vn,
      easy: easy,
      es:es
    }
  })
}



// WEBPACK FOOTER //
// ./src/i18n/index.js